<template>
    <div>
        <div class="form-info">
            <el-form :model="msgInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <div class="form-row">
                    <div class="form-label">
                        <label class="required">标题</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="txt">
                            <el-input v-model="msgInfo.txt" type="text"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-row" style="height: 90px">
                    <div class="form-label">
                        <label class="required">内容</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="data">
                            <el-input v-model="msgInfo.data" type="textarea"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </div>
        <!--<div class="content-caption dashed bg-white">人员列表</div>-->
        <div v-if="useStaff()" class="form-info">
            <div class="form-row">
                <div class="form-label">
                    <label>&nbsp;</label>
                </div>
                <div class="form-value">
                    <!-- 人员列表 -->
                    <swb-com-staff-list-for-msg ref="swb_com_staff_list_for_msg"></swb-com-staff-list-for-msg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import comStaffListForMsg from '../orgStruct/ComStaffListForMsg'
    Vue.regist(comStaffListForMsg);

    export default{
        name: 'swb-send-msg',
        desc: '站点信',
        props: {
            //目标接收者类型
            targetType: {
                type: String,
                //com , post, staff
                default: null
            },

        },
        data: function () {
            return {
                msgInfo: {
                    data: null,
                    txt: null,
                },
                rules: {
                    data: [
                        {required: true, message: '请输入标题', trigger: 'blur'},
                    ],
                    txt: [
                        {required: true, message: '请输入内容', trigger: 'blur'},
                    ],
                }
            }
        },
        created: function () {
        },
        methods: {
            useStaff(){
                return this.targetType != null && this.targetType.isIn('staff');
            },
            usePost(){
                return this.targetType != null && this.targetType.isIn('staff', 'post');
            },
            useCom(){
                return this.targetType != null && this.targetType.isIn('staff', 'post', 'com');
            },
            getResultData: function () {
                let self = this;
                let resultData = {};
                //
                let validOk = true;
                this.$refs["ruleForm"].validate(function (valid) {
                    validOk = valid && validOk;
                    //
                    if(valid) {
                        resultData.msgInfo = Utils.merge(self.msgInfo);
                    }
                });
                //
                if(validOk) {
                    if(this.useStaff()) {
                        let result = self.$refs.swb_com_staff_list_for_msg.getDlgResult() || null;
                        //
                        if(result.type === 'info') {
                            //
                            resultData.staffIds = result.data;
                        }
                    }
                }
                //
                return resultData;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/msg/SendMsg.vue